import React, { useState, useEffect } from 'react';
import { useUserProfile } from '../hooks/useUserProfile';

const Notifications = ({ user }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Get current user from AWS Cognito
  const [currentUser, setCurrentUser] = useState(null);
  
  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        const { Auth } = await import('aws-amplify');
        const user = await Auth.currentAuthenticatedUser();
        setCurrentUser(user);
      } catch (error) {
        console.log('No authenticated user');
      }
    };
    getCurrentUser();
  }, []);
  
  const { userProfile, loading: profileLoading } = useUserProfile(currentUser?.username);

  useEffect(() => {
    const loadNotifications = async () => {
      if (!user) return;
      
      try {
        const response = await fetch(`https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/users/${user.username}/notifications`);
        if (response.ok) {
          const data = await response.json();
          // Convert DynamoDB format to frontend format
          const formattedNotifications = data.map((item, index) => ({
            id: index + 1,
            vendor: "Sakshin's Flower Shop", // Could be extracted from message or vendor lookup
            subject: "Floral Contract",
            message: item.message,
            time: "2h", // Could calculate from createdAt
            unread: true,
            icon: "🌸"
          }));
          setNotifications(formattedNotifications);
        }
      } catch (error) {
        console.error('Error loading notifications:', error);
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    loadNotifications();
  }, [user]);

  if (loading || profileLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '16px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #E5E7EB',
          borderTop: '3px solid #6B9080',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <div style={{ color: '#6B7280', fontSize: '16px' }}>
          Loading notifications...
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <div style={{
        backgroundColor: '#E8F4E8',
        padding: '48px 24px',
        textAlign: 'center'
      }}>
        <h1 style={{ 
          fontSize: '56px', 
          fontWeight: '400', 
          color: '#1F2937',
          margin: 0,
          fontFamily: 'Georgia, serif',
          letterSpacing: '-0.02em'
        }}>
          Notifications
        </h1>
      </div>

      {/* Notifications List */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px' }}>
        {notifications.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '48px 24px',
            color: '#6B7280'
          }}>
            No notifications yet
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {notifications.map((notification) => (
            <div
              key={notification.id}
              style={{
                padding: '20px',
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                display: 'flex',
                alignItems: 'center',
                gap: '16px'
              }}
            >
              <div style={{
                width: '48px',
                height: '48px',
                backgroundColor: '#E8F4E8',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}>
                {notification.icon}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '18px', fontWeight: '500', color: '#1F2937', marginBottom: '4px' }}>
                  {notification.vendor} - {notification.subject}
                </div>
                <div style={{ fontSize: '14px', color: '#6B7280' }}>
                  {notification.message}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ fontSize: '14px', color: '#6B7280' }}>
                  {notification.time}
                </div>
                {notification.unread && (
                  <div style={{ width: '8px', height: '8px', backgroundColor: '#EF4444', borderRadius: '50%' }}></div>
                )}
              </div>
            </div>
          ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Notifications;